<div class="p-4">
    <breadcrumb [items]="breadcrumb"></breadcrumb>
    <mat-card>
        <mat-card-content>
            <div class="d-flex align-items-end mb-3">
                <h1 class="fs-3 fw-light mb-0">Regras de Apontamento</h1>
                <mat-form-field appearance="outline" class="input-sm ms-auto me-3">
                    <mat-label>Filtrar regras</mat-label>
                    <input matInput [(ngModel)]="filter" [(ngModel)]="filter" (ngModelChange)="search()">
                    <button mat-icon-button matSuffix (click)="search()">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
                <button mat-flat-button color="primary" [routerLink]="['nova']">NOVA REGRA DE APONTAMENTO</button>
            </div>
            <generate-table [dataSource]="dataSource" [columns]="columns" [loading]="loading"></generate-table>
        </mat-card-content>
    </mat-card>
</div>